export var CustomEvents;
(function (CustomEvents) {
    CustomEvents["translations"] = "translations";
    CustomEvents["loadingProgress"] = "loadingProgress";
    CustomEvents["readyForDisciplineInit"] = "readyForDisciplineInit";
    CustomEvents["startInstructionsPhase"] = "startInstructionsPhase";
    CustomEvents["startIntroPhase"] = "startIntroPhase";
    CustomEvents["startStartListPhase"] = "startStartListPhase";
    CustomEvents["startDisciplinePhase"] = "startDisciplinePhase";
    CustomEvents["startProvisionalResultsPhase"] = "startProvisionalResultsPhase";
    CustomEvents["startFinalStandingsPhase"] = "startFinalStandingsPhase";
    CustomEvents["startFinalTrainingPhase"] = "startFinalTrainingPhase";
    CustomEvents["finishPhase"] = "finishPhase";
    CustomEvents["finishDisciplinePhase"] = "finishDisciplinePhase";
    CustomEvents["instructionsButtonActive"] = "instructionsButtonActive";
    CustomEvents["gameStart"] = "gameStart";
    CustomEvents["allRequestDoneOnEnd"] = "allRequestDoneOnEnd";
    CustomEvents["finalRedirectDone"] = "finalRedirectDone";
    CustomEvents["typeWrite"] = "typeWrite";
    CustomEvents["tutorialGameEvent"] = "tutorialGameEvent";
    CustomEvents["errorOccured"] = "errorOccured";
    CustomEvents["toggleBackgroundMode"] = "toggleBackgroundMode";
    CustomEvents["firstUpdateDone"] = "firstUpdateDone";
})(CustomEvents || (CustomEvents = {}));
//# sourceMappingURL=events.js.map